(() => {
  const mapping = {
    '~~': 'strike',
    '~': 'strike',
    '**': 'strong',
    __: 'strong',
    '*': 'em',
    _: 'em',
  };

  window.swinger = window.swinger || {};
  window.swinger.md = (text) => {
    Object.keys(mapping).forEach((key) => {
      const parts = text.split(key);

      text = '';

      parts.forEach((part, index) => {
        if (index && index % 2 === 1) {
          text += `<${mapping[key]}>`;
        }
        if (index && index % 2 === 0) {
          text += `</${mapping[key]}>`;
        }

        text += part;
      });
    });

    return text;
  };
})();
